import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface ILocationIntroColumn {
	/**
	 * Column Heading
	 */
	columnHeading?: string;
	/**
	 * Column Content
	 * @control richtext
	 */
	columnContent?: string;
}

export interface ILocationIntroContentProps extends IBaseElementProps {
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Intro Text
	 */
	introText?: string;
	/**
	 * Location Intro Columns
	 */
	columns?: ILocationIntroColumn[];
}

/**
 * Location Intro Content
 * @block
 * @icon columns
 */
const LocationIntroContent: React.FC<ILocationIntroContentProps> =
	({ id, className, classNames = [], heading, introText, columns }) => (
		<div
			id={id}
			className={
				className || cn('calian-location-intro-content', ...classNames)
			}
		>
			<div className="calian-location-intro-content__container container-fluid">
				<div className="row">
					<div className="calian-location-intro-content__top col-12">
						{heading && (
							<h2 className="calian-location-intro-content__heading">
								{heading}
							</h2>
						)}
						{introText && (
							<p className="calian-location-intro-content__intro-text">
								{introText}
							</p>
						)}
					</div>
				</div>
				<div className="row">
					{columns?.map((column, index) => (
						<div
							key={index}
							className="calian-location-intro-content__column col-12 col-lg-4"
						>
							{column.columnHeading && (
								<h3 className="calian-location-intro-content__column-heading">
									{column.columnHeading}
								</h3>
							)}
							{column.columnContent && (
								<div
									className="calian-location-intro-content__column-content"
									dangerouslySetInnerHTML={{
										__html: column.columnContent,
									}}
								/>
							)}
						</div>
					))}
				</div>
			</div>
		</div>
	);

export default LocationIntroContent;
